/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import DOMPurify from 'dompurify';
import { Notification, updateNotification } from '../../../../store/Notifications';
import { TextBlock } from '../../../Atoms/Text';
import { InventoryAsset } from '../../../../types';
import { formatDate } from '../../../../utils/helpers';

export const UpcomingExpiration = ({ notification, days }: { notification: Notification; days: string }) => {
  const message = notification.notification_message;
  const entity = message.content.entity as InventoryAsset;
  const messageText = `According to our records your ${entity.supplier?.name} service 
    is set to expire/renew in ${days} days on ${formatDate(entity.contractEndDate)}.
    The UPSTACK Team will reach out to discuss.`;

  return (
    <div
      className="space-y-1 hover:cursor-pointer ml-9"
      onClick={() =>
        updateNotification({
          ...notification,
          is_read: true
        })
      }>
      <TextBlock
        size="sm"
        weight="normal">
        {(DOMPurify.sanitize(messageText, { RETURN_DOM: true }) as HTMLElement).innerText}
      </TextBlock>
    </div>
  );
};
